<ion-app>
    <ion-split-pane
        contentId="public"
        when="(min-width: 1280px)"
        (ionSplitPaneVisible)="splitPaneVisibleChanged($event)"
        [disabled]="!(showSplitpane$ | async)"
    >
        <ion-menu contentId="public" type="overlay" class="xl:w-48">
            <ion-header>
                <ion-toolbar />
            </ion-header>

            <ion-content class="border-light border-solid" [ngClass]="splitPaneVisible ? 'border-r-[1px]' : ''">
                <div class="w-full min-h-full flex flex-col justify-between">
                    <div class="w-full flex flex-col gap-2">
                        <div class="w-full flex items-center justify-center p-5">
                            <img src="assets/img/logo.png" class="object-contain w-4/5 mb-5" />
                        </div>

                        <ion-list [inset]="true">
                            @for (infoPage of informationPages; track infoPage.path) {
                                <ion-menu-toggle [autoHide]="false">
                                    <ion-item
                                        routerDirection="root"
                                        [routerLink]="infoPage.path"
                                        color="light"
                                        [button]="true"
                                        [detail]="true"
                                    >
                                        <ion-icon color="primary" [name]="infoPage.icon" slot="start"></ion-icon>
                                        <ion-label
                                            ><span class="hyphens-auto" lang="sv">{{ infoPage.title }}</span></ion-label
                                        >
                                    </ion-item>
                                </ion-menu-toggle>
                            }
                        </ion-list>
                    </div>

                    <ion-list [inset]="true">
                        <ion-item
                            routerDirection="root"
                            [routerLink]="(user$ | async) ? '/admin' : '/auth'"
                            color="light"
                            [button]="true"
                            [detail]="true"
                        >
                            <ion-icon color="primary" [name]="(user$ | async) ? 'build-outline' : 'key-outline'" slot="start"></ion-icon>
                            <ion-label>{{ (user$ | async) ? 'Administratör' : 'Logga in' }}</ion-label>
                        </ion-item>
                    </ion-list>
                </div>
            </ion-content>
        </ion-menu>

        <ion-router-outlet id="public" />
    </ion-split-pane>
</ion-app>
